// Секция «Наши поля» на карточках компании, контакта и судна: поля, которые владелец
// завёл в конструкторе «Поля карточек». Живут в СВОЕЙ схеме ядра (field_def/field_value),
// в Bitrix не пишутся; правка — POST /api/cards-write/field-value-save через страницу.
//
// Пустота всегда объяснена, потому что это три РАЗНЫХ ответа: «полей не завели»
// (конструктор пуст), «карточка не перенесена в свою базу» (значениям некуда цепляться)
// и «ядро отказало» (словами отказа). Склеить их в пустую секцию значило бы заставить
// человека гадать, куда делись его поля.
import { нашиПоляКакСтроки, почемуНедоступно } from '../api/cardLiveEntities'
import type { useНашиПоля } from '../api/cardLiveEntities'
import type { useRightsApi } from '../api/hooks'

import { FieldSection } from './card/FieldSection'

export function OwnFieldsSection({ сущностьМн, ownId, наши, rights, onSave, почему }: {
  /** «компаний» / «контактов» / «судов» — для фразы «полей для … не завели». */
  сущностьМн: string
  ownId: number | null
  наши: ReturnType<typeof useНашиПоля>
  rights: ReturnType<typeof useRightsApi>
  onSave?: (code: string, value: unknown) => Promise<void>
  /** Готовая причина недоступности — когда страница знает её точнее общей («это судно»). */
  почему?: string
}) {
  const причина = почему ?? почемуНедоступно(ownId, наши.error)
  const поля = нашиПоляКакСтроки(наши.data)
  return (
    <FieldSection title="Наши поля" fields={причина ? [] : поля} onSave={onSave}>
      {причина && <div className="hint" style={{ marginTop: 6 }}>{причина}</div>}
      {!причина && наши.data && поля.length === 0 && (
        <div className="hint" style={{ marginTop: 6 }}>
          Своих полей для {сущностьМн} владелец ещё не завёл — они добавляются в разделе
          «Поля карточек» и появляются здесь сразу.
        </div>
      )}
      {!причина && поля.length > 0 && !rights.canWrite && (
        <div className="hint" style={{ marginTop: 6 }}>
          Править поля вашей роли{rights.roleTitle ? ` («${rights.roleTitle}»)` : ''} нельзя —
          раздел открыт только на чтение.
        </div>
      )}
      {!причина && поля.length > 0 && rights.canWrite && (
        <div className="hint" style={{ marginTop: 6 }}>
          Эти поля живут в своей базе CRM и в Bitrix не пишутся.
        </div>
      )}
    </FieldSection>
  )
}
